// extracted by mini-css-extract-plugin
var _1 = "GOG_xjfhuL";
var _2 = "AesJV3kRqm";
var _3 = "cpb6XqHcj3";
var _4 = "VcXJfo3fJT";
export { _1 as "anonymous", _2 as "avatar", _3 as "name", _4 as "root" }
